var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-settings-popup",
    {
      attrs: {
        resources: {
          deletePromptTitle: _vm.resource(
            "JourneyBuilder_JourneySettings_Delete_Title"
          ),
          deletePromptBody: _vm.resource(
            "JourneyBuilder_JourneySettings_Delete_Body"
          ),
          brickTitle:
            _vm.resource("JourneyComposer_BrickSettingsJourney_Title") +
            " " +
            _vm.resource("JourneyComposer_BrickSettingsBase_Title")
        },
        brick: _vm.brick,
        name: _vm.newName
      },
      on: {
        "update:name": function($event) {
          _vm.newName = $event
        },
        save: function($event) {
          return _vm.saveSettings()
        },
        delete: function($event) {
          return _vm.$emit("delete")
        },
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _c("settings-item", {
        attrs: {
          icon: "fas fa-route",
          label: _vm.resource("JourneyBuilder_Shared_Journey")
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function(ref) {
              var id = ref.id
              return [
                _c("journey-dropdown", {
                  attrs: {
                    id: id,
                    "extra-journeys": _vm.externalJourneys,
                    disabled: !_vm.canWrite
                  },
                  model: {
                    value: _vm.journeyIdModel,
                    callback: function($$v) {
                      _vm.journeyIdModel = $$v
                    },
                    expression: "journeyIdModel"
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }